import { render, staticRenderFns } from "./Share.vue?vue&type=template&id=37719d8e&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Share.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/Share.vue
// module id = 2431
// module chunks = 1